import { defineAsyncComponent } from 'vue';
// import { RouterView } from 'vue-router';
import isApplicant from './middleware/isApplicant';
import isApplicantV3 from './middleware/isApplicantV3';
import isDrivers from './middleware/isDrivers';
import isDriversV3 from './middleware/isDriversV3';
import isPhone from './middleware/isPhone';
import isDocumentSigned from './middleware/isDocumentSigned';
import isDocumentSignedSkip from './middleware/isDocumentSignedSkip';
import isDocusingFinal from './middleware/isDocusingFinal';
import zrater from './modules/zrater';
const isDeveloper = import.meta.env.DEV;

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/MapStartPage.vue'),
    // redirect: { name: 'insurance.quick' },
    meta: {
      // navbar: false,
    },
  },

  {
    path: '/test',
    name: 'test',
    component: () => defineAsyncComponent(() => import('@/views/TestPage.vue')),
    meta: {
      // navbar: false,
    },
  },
  {
    path: '/rater',
    // name: "insurance.home",
    component: () => import('@/views/InsurancePage.vue'),
    meta: {
      title: 'Dashboard',
    },
    children: [
      {
        path: '',
        name: 'insurance.applicant',
        component: () => import('@/views/insurance/Applicant.vue'),
        meta: {
          title: 'Applicant',
          step: 1,
        },
      },

      {
        path: 'vehicles',
        name: 'insurance.vehicles',
        component: defineAsyncComponent(() => import('@/views/insurance/Vehicles.vue')),
        meta: {
          title: 'Vehicles',
          step: 2,
          middleware: [isApplicant],
        },
      },
      {
        path: 'drivers',
        name: 'insurance.drivers',
        component: defineAsyncComponent(() => import('@/views/insurance/Drivers.vue')),
        meta: {
          title: 'Drivers',
          step: 3,
          middleware: [isApplicant],
        },
      },
      {
        path: 'quote',
        // name: "insurance.quote",
        component: defineAsyncComponent(() => import('@/views/insurance/Quote.vue')),
        children: [
          {
            path: '',
            name: 'insurance.quote',
            component: defineAsyncComponent(() => import('@/views/insurance/quote/Buy.vue')),
            meta: {
              title: 'Quote',
            },
          },
          {
            path: 'phone-verification',
            name: 'insurance.quote.phone',
            component: defineAsyncComponent(
              () => import('@/views/insurance/quote/VerificationPhone.vue')
            ),
            meta: {
              title: 'Phone verification',
            },
          },
        ],
        meta: {
          title: 'Quote',
          step: 4,
          middleware: [isApplicant, isDrivers],
        },
      },
      // v3 form flow — parallel QA routes (/rater/v3/*), legacy paths unchanged
      {
        path: 'v3',
        name: 'insurance.v3.applicant',
        component: () => import('@/views/insurance/applicant/v3/ApplicantProvider.vue'),
        meta: {
          title: 'Applicant Information (v3)',
          step: 1,
        },
      },
      {
        path: 'v3/vehicles',
        name: 'insurance.v3.vehicles',
        component: defineAsyncComponent(
          () => import('@/views/insurance/vehicles/v3/VehiclesProvider.vue')
        ),
        meta: {
          title: 'Vehicles (v3)',
          step: 2,
          middleware: [isApplicantV3],
        },
      },
      {
        path: 'v3/drivers',
        name: 'insurance.v3.drivers',
        component: defineAsyncComponent(
          () => import('@/views/insurance/drivers/v3/DriversProvider.vue')
        ),
        meta: {
          title: 'Drivers (v3)',
          step: 3,
          middleware: [isApplicantV3],
        },
      },
      {
        path: 'v3/quote',
        component: defineAsyncComponent(() => import('@/views/insurance/Quote.vue')),
        children: [
          {
            path: '',
            name: 'insurance.v3.quote',
            component: defineAsyncComponent(
              () => import('@/views/insurance/quote/v3/QuoteProvider.vue')
            ),
            meta: {
              title: 'Quote (v3)',
            },
          },
        ],
        meta: {
          title: 'Quote (v3)',
          step: 4,
          middleware: [isApplicantV3, isDriversV3],
        },
      },
      {
        path: 'docusign',
        name: 'insurance.quote.docu',
        component: defineAsyncComponent(() => import('@/views/insurance/quote/DocuSign.vue')),
        meta: {
          title: 'Docu Sign',
          step: 4,
          middleware: [isPhone, isDocumentSignedSkip],
        },
      },
      {
        path: 'payment',
        name: 'insurance.payment',
        component: defineAsyncComponent(() => import('@/views/insurance/Payment.vue')),
        meta: {
          title: 'payment',
          step: 5,
          middleware: [isPhone],
        },
      },
      {
        path: 'final',
        name: 'insurance.final',
        component: defineAsyncComponent(() => import('@/views/insurance/FinalPage.vue')),
        meta: {
          title: 'Final information',
          step: 5,
          middleware: [isPhone],
        },
      },
      {
        path: 'esign-completed',
        name: 'insurance.final.docusign',
        component: () => import('@/views/insurance/DocusignFinalPage.vue'),
        meta: {
          title: 'Contract documents signed.',
        },
      },
    ],
  },
  {
    path: '/pre-quote',
    name: 'insurance.quick',
    component: () => import('@/views/insurance/QuickStart.vue'),
    meta: {
      navbar: false,
    },
  },
  {
    path: '/payment',
    // name: "insurance.home",
    component: () => import('@/views/PaymentPortalPage.vue'),
    meta: {
      title: 'Payment Portal',
    },
    children: [
      {
        path: '',
        name: 'payment.portal',
        component: () => import('@/views/payment_portal/FormPageGlobal.vue'),
        meta: {
          title: 'Payment Portal',
        },
      },
      {
        path: 'old',
        name: 'payment.portal.old',
        component: () => import('@/views/payment_portal/FormPage.vue'),
        meta: {
          title: 'Payment Portal old',
        },
      },
      {
        path: 'pay',
        name: 'payment.portal.stripe',
        component: () => import('@/views/payment_portal/PaymentPage.vue'),
        meta: {
          title: 'Payment',
        },
      },
      {
        path: 'final',
        name: 'payment.portal.final',
        component: () => import('@/views/payment_portal/PaymentPortalFinal.vue'),
        meta: {
          title: 'Final',
        },
      },
    ],
  },
  // ...(isDeveloper ? zrater : []),
  ...zrater,
  {
    path: '/renewal',
    component: () => import('@/views/RenewQuote.vue'),
    meta: {
      navbar: false,
    },
    children: [
      {
        path: '',
        name: 'renew.overview',
        component: () => import('@/views/renewal/Overview.vue'),
        meta: {
          title: 'Renew Quote',
        },
      },
      {
        path: 'pay',
        name: 'renew.stripe',
        component: () => import('@/views/renewal/PaymentPage.vue'),
        meta: {
          title: 'Payment',
        },
      },
      {
        path: 'final',
        name: 'renew.final',
        // component: () => import("@/views/renewal/PaymentPortalFinal.vue"),
        component: () => import('@/views/insurance/FinalPage.vue'),
        meta: {
          title: 'Final',
        },
      },
    ],
  },
  {
    path: '/contract',
    name: 'payment.contract',
    component: () => defineAsyncComponent(() => import('@/views/contract/ContractPortal.vue')),
    meta: {
      navbar: false,
    },
  },
  {
    path: '/sf-sms-verification',
    name: 'phone.verification',
    component: () => import('@/views/phone-verification-form/SfSmsVerification.vue'),
  },
  {
    path: '/info-portal',
    name: 'InfoPortal',
    component: () => defineAsyncComponent(() => import('@/views/InfoPortal.vue')),
  },
  {
    path: '/nsd-addon',
    component: () => import('@/views/NsdAdditional.vue'),
    name: 'nsd.list',
  },
  {
    path: '/nsd-addon/:id',
    component: () => import('@/views/NsdAddon.vue'),
    // name: "nsd.single",
    children: [
      {
        path: '',
        name: 'nsd.addon',
        component: () => import('@/views/nsd/SingleItem.vue'),
      },
      {
        path: 'payment',
        name: 'nsd.payment',
        component: () => import('@/views/nsd/Payment.vue'),
      },
      {
        path: 'final',
        name: 'nsd.final',
        component: () => import('@/views/nsd/FinalPage.vue'),
      },
    ],
  },

  //store NSD
  {
    path: '/nsd-addon/store',
    component: () => import('@/views/NsdStore.vue'),
    // name: "nsd.single",
    children: [
      {
        path: '',
        name: 'nsd.store',
        component: () => import('@/views/nsd/NsdItems.vue'),
      },
      {
        path: 'cart',
        name: 'nsd.store.cart',
        component: () => import('@/views/nsd/SingleItem.vue'),
      },
      {
        path: 'payment',
        name: 'nsd.store.payment',
        component: () => import('@/views/nsd/Payment.vue'),
      },
      {
        path: 'final',
        name: 'nsd.store.final',
        component: () => import('@/views/nsd/FinalPage.vue'),
      },
    ],
  },
  //store NSD

  {
    path: '/clear',
    name: 'ClearState',
    component: () => import('@/views/insurance/ClearState.vue'),
  },
  {
    path: '/test',
    name: 'TEST PAGE',
    component: () => import('@/views/TestPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: defineAsyncComponent(() => import('@/views/errors/NotFound.vue')),
    meta: {
      title: 'Not Found',
    },
  },
];

export default routes;
